import { render, staticRenderFns } from "./MemoDeal.vue?vue&type=template&id=48a356aa&scoped=true&"
import script from "./MemoDeal.vue?vue&type=script&lang=js&"
export * from "./MemoDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a356aa",
  null
  
)

export default component.exports